/* eslint-disable sort-keys */
import {
    CREATE_SESSION_REQUEST,
    CREATE_SESSION_SUCCESS,
    CREATE_SESSION_ERROR,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    IS_LOGGED_IN_REQUEST,
    IS_LOGGED_IN_SUCCESS,
    IS_LOGGED_IN_ERROR,
    USER_PROFILE_REQUEST,
    USER_PROFILE_SUCCESS,
    USER_PROFILE_ERROR,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOGOUT_ERROR,
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_ERROR,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_ERROR,
    MARK_USER_ACTIVE_REQUEST,
    MARK_USER_ACTIVE_SUCCESS,
    MARK_USER_ACTIVE_ERROR,
    GET_USER_ACCESSIBLE_ITEMS_REQUEST,
    GET_USER_ACCESSIBLE_ITEMS_SUCCESS,
    GET_USER_ACCESSIBLE_ITEMS_ERROR,
    OTP_RESEND_REQUEST,
    OTP_RESEND_SUCCESS,
    OTP_RESEND_ERROR,
    OTP_VALIDATE_REQUEST,
    OTP_VALIDATE_SUCCESS,
    OTP_VALIDATE_ERROR,
    RESET_OTP_FLAG,
} from './auth.constants';

// Create Session
export const createSessionRequest = history => ({
    type: CREATE_SESSION_REQUEST,
    history,
});

export const createSessionSuccess = payload => ({
    type: CREATE_SESSION_SUCCESS,
    payload,
});

export const createSessionError = payload => ({
    type: CREATE_SESSION_ERROR,
    payload,
});

// Login
export const loginRequest = payload => ({ type: LOGIN_REQUEST, payload });

export const loginSuccess = payload => ({
    type: LOGIN_SUCCESS,
    payload,
});

export const loginError = payload => ({
    type: LOGIN_ERROR,
    payload,
});

// Is Logged In
export const isLoggedInRequest = () => ({
    type: IS_LOGGED_IN_REQUEST,
});

export const isLoggedInSuccess = payload => ({
    type: IS_LOGGED_IN_SUCCESS,
    payload,
});

export const isLoggedInError = payload => ({
    type: IS_LOGGED_IN_ERROR,
    payload,
});

// User Profile
export const userProfileRequest = () => ({
    type: USER_PROFILE_REQUEST,
});

export const userProfileSuccess = payload => ({
    type: USER_PROFILE_SUCCESS,
    payload,
});

export const userProfileError = payload => ({
    type: USER_PROFILE_ERROR,
    payload,
});

// Logout
export const logoutRequest = () => ({ type: LOGOUT_REQUEST });

export const logoutSuccess = payload => ({
    type: LOGOUT_SUCCESS,
    payload,
});

export const logoutError = payload => ({
    type: LOGOUT_ERROR,
    payload,
});

// Forgot Password
export const forgotPasswordRequest = payload => ({
    type: FORGOT_PASSWORD_REQUEST,
    payload,
});

export const forgotPasswordSuccess = payload => ({
    type: FORGOT_PASSWORD_SUCCESS,
    payload,
});

export const forgotPasswordError = payload => ({
    type: FORGOT_PASSWORD_ERROR,
    payload,
});

// Reset Password
export const resetPasswordRequest = payload => ({
    type: RESET_PASSWORD_REQUEST,
    payload,
});

export const resetPasswordSuccess = payload => ({
    type: RESET_PASSWORD_SUCCESS,
    payload,
});

export const resetPasswordError = payload => ({
    type: RESET_PASSWORD_ERROR,
    payload,
});

// Mark User Active
export const markUserActiveRequest = payload => ({
    type: MARK_USER_ACTIVE_REQUEST,
    payload,
});

export const markUserActiveSuccess = payload => ({
    type: MARK_USER_ACTIVE_SUCCESS,
    payload,
});

export const markUserActiveError = payload => ({
    type: MARK_USER_ACTIVE_ERROR,
    payload,
});

// Reset Password
export const getUserAccessibleItemsRequest = () => ({
    type: GET_USER_ACCESSIBLE_ITEMS_REQUEST,
});

export const getUserAccessibleItemsSuccess = payload => ({
    type: GET_USER_ACCESSIBLE_ITEMS_SUCCESS,
    payload,
});

export const getUserAccessibleItemsError = payload => ({
    type: GET_USER_ACCESSIBLE_ITEMS_ERROR,
    payload,
});

// Resend Otp
export const resendOtpRequest = payload => ({
    type: OTP_RESEND_REQUEST,
    payload,
});

export const resendOtpSuccess = payload => ({
    type: OTP_RESEND_SUCCESS,
    payload,
});

export const resendOtpError = payload => ({
    type: OTP_RESEND_ERROR,
    payload,
});

// Validate Otp
export const validateOtpRequest = payload => ({
    type: OTP_VALIDATE_REQUEST,
    payload,
});

export const validateOtpSuccess = payload => ({
    type: OTP_VALIDATE_SUCCESS,
    payload,
});

export const validateOtpError = payload => ({
    type: OTP_VALIDATE_ERROR,
    payload,
});

export const resetOtpFlag = () => ({
    type: RESET_OTP_FLAG,
});
